module.exports = __webpack_public_path__ + "static/media/la.0f6d9c11.svg";